module.exports = __webpack_public_path__ + "img/362.08b710e7.svg";